import React from 'react';

import ConfirmationExitBox from '../../ConfirmationExitBox';
import config from '../../../../config/config';
import planningDetails from '../../../../assets/images/planning-details.svg';
import dollarSignMonitor from '../../../../assets/images/dollar-sign-monitor.svg';
import sellDashboard from '../../../../assets/images/sell-dashboard.svg';

export const QCDWhatsNext = () => (
  <div className="buy-whats-next-exit-container">
    <div>
      <div className="buy-whats-next-exit-heading">What's next?</div>
      <div className="row">
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-setup-recurring'}
            className={'e2e-confirm-setup-recurring'}
            heading={'Go to MyRMD page'}
            subHeading={`Take a look at your overall planning details and explore our simulation tools.`}
            image={planningDetails}
            exitLocation={`${config.url}/usis/rmd-tool`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-expand-portfolio'}
            className={'e2e-confirm-expand-portfolio'}
            heading={'Make Another Transaction'}
            subHeading={`Buy, sell, or exchange using your T. Rowe Price accounts.`}
            image={dollarSignMonitor}
            exitLocation={`${config.url}/usis/transactions/landing`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-view-dashboard'}
            className={'e2e-confirm-view-dashboard'}
            heading={'View Your Dashboard'}
            subHeading={`Review your portfolio and track how your investments are performing.`}
            image={sellDashboard}
            exitLocation={`${config.url}/usis/my-accounts/dashboard`}
          />
        </div>
      </div>
    </div>
  </div>
);

export default QCDWhatsNext;
